// extracted by mini-css-extract-plugin
export default {"MailchimpModalWrapper":"MailChimpManagerModal_MailchimpModalWrapper__fmJS5"};